import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { getPaymentDeductionGroupStatus } from 'Utils/getPaymentStatus';

interface IGroupStatus {
  groupStatus: number;
}

export const GroupStatus = ({ groupStatus }: IGroupStatus) => {
  const status = getPaymentDeductionGroupStatus(
    groupStatus,
    Dictionary[DICTIONARY.PaymentsDeductions].paymentDeductionCard.groupStatus
  );

  return (
    <Stack
      position='absolute'
      left={0}
      top={0}
      direction='row'
      alignItems='center'
      gap='9px'
      width='fit-content'
      bgcolor='purple2.shade_100'
      padding='8px 16px'
      borderRadius='16px 0'
    >
      <Avatar
        alt=''
        src={status.image}
        sx={{ width: '15px', height: '15px' }}
      />
      <Typography variant={'body5'}>{status.text}</Typography>
    </Stack>
  );
};
